import { render, staticRenderFns } from "./ProductItemVariation.vue?vue&type=template&id=1d5d3f61&scoped=true"
import script from "./ProductItemVariation.vue?vue&type=script&lang=js"
export * from "./ProductItemVariation.vue?vue&type=script&lang=js"
import style0 from "./ProductItemVariation.vue?vue&type=style&index=0&id=1d5d3f61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5d3f61",
  null
  
)

export default component.exports